export default __webpack_public_path__ + "static/WPT_Global_list_view-82894848c171f0a648aef65c55baac09.png";